import React from 'react';

export const Section = ({ 
  children, 
  className = '',
  id,
  background = 'default' // 'default', 'secondary'
}) => {
  const bgClass = background === 'secondary' ? 'bg-background-secondary' : 'bg-background';
  
  return (
    <section 
      id={id}
      className={`section-spacing ${bgClass} ${className}`}
    >
      <div className="editorial-container">
        {children}
      </div>
    </section>
  );
};

export const SectionHeading = ({ children, className = '' }) => {
  return (
    <h2 className={`mb-5 text-balance ${className}`}>
      {children}
    </h2>
  );
};

export const SectionSubheading = ({ children, className = '' }) => {
  return (
    <p className={`font-serif text-xl md:text-2xl italic text-muted-foreground mb-5 ${className}`}>
      {children}
    </p>
  );
};

export default Section;
